/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：534
 */

var /* [auto-meaningful-name] */require_300_$$_1648_300_index$f = require(/* 300 */"../1648/300/index").f
var o = require(/* 334 */"../1648/334")
var i = require(/* 246 */"../1782/246/index")("toStringTag")
module.exports = function (e, t, n) {
  if (e && !o(e = n ? e : e.prototype, i)) {
    require_300_$$_1648_300_index$f(e, i, {
      configurable: true,
      value: t
    })
  }
}
